<app-header [search]="true" [enableBack]="false">
  <div title>
    {{ 'meteringpoint.csvupload.title' | translate }}
  </div>
</app-header>
<div class="p-6">
  <app-card>
    <div class="flex gap-4">
      <div class="w-1/4">
        <form [formGroup]="form">
          <app-input-group>
            <label appLabel>{{ 'meteringpoint.csvupload.filename' | translate}}:</label>
            <input type="file"
                   accept=".csv"
                   (change)="onFileSelected($event)"
                   [disabled]="uploading"
                   #fileInput/>
          </app-input-group>
          <app-input-group>
            <label class="ec-toggle-label">
              {{ 'meteringpoint.timeseries.submit.wantslocked' | translate }}
              <app-toggle formControlName="shouldBeLocked"></app-toggle>
            </label>
          </app-input-group>
        </form>
        <app-input-group>
          <button appButton type="primary" (click)="uploadFile()"
                  [disabled]="form.invalid || uploading">
            {{ (uploading ? 'meteringpoint.csvupload.uploading' : 'meteringpoint.csvupload.upload') | translate }}
          </button>
        </app-input-group>
      </div>
      <div class="w-3/4">
        <div class="file-input-container">
          <!-- reserved for layout consistency -->
        </div>
      </div>
    </div>
  </app-card>
  <app-table
    [config]="manualTimeseriesResultTable"
    [data]="recentImports" (selectedElementsChange)="onRowSelected($event)">
  </app-table>
</div>
